import { RecoilEnv } from "recoil";

/**
 * DHT-4705: OSS Recoil cannot tell a Fast Refresh re-registration from a real
 * duplicate key (`isFastRefreshEnabled()` is hard-coded false), so every edit
 * to a file that declares an atom raised `Duplicate atom key "…". This is a
 * FATAL ERROR in production.` as a console.error in dev builds, which Datadog
 * then recorded as an error.
 *
 * The check is switched off in `__DEV__` only. Release builds keep it. Real
 * duplicates are caught before merge instead, by
 * `__tests__/recoilKeysUnique.test.ts`.
 *
 * Imported first by every entry file, before any module declares an atom.
 */
export const configureRecoilEnv = (isDev: boolean) => {
  if (isDev) RecoilEnv.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = false;
};

configureRecoilEnv(__DEV__);
